import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Icon from '../Icon';
import classNames from 'classnames';
import { isFunction } from '@utiljs/is';

var AccordionPanel = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AccordionPanel, _React$PureComponent);

  var _super = _createSuper(AccordionPanel);

  function AccordionPanel() {
    var _this;

    _classCallCheck(this, AccordionPanel);

    _this = _super.apply(this, arguments);

    _this.handlePanelClick = function () {
      var _this$props = _this.props,
          panelKey = _this$props.panelKey,
          disabled = _this$props.disabled,
          onPanelClick = _this$props.onPanelClick;
      if (isFunction(onPanelClick) && !disabled) onPanelClick(panelKey);
    };

    _this.renderIcon = function () {
      var _this$props2 = _this.props,
          isActive = _this$props2.isActive,
          arrowPosition = _this$props2.arrowPosition;
      var className = classNames({
        'roo-accordion-panel-header-icon': true,
        'roo-accordion-panel-header-icon-right': arrowPosition === 'right'
      });
      return /*#__PURE__*/React.createElement(Icon, {
        name: "".concat(isActive ? 'chevron-down' : 'chevron-right'),
        className: className
      });
    };

    return _this;
  }

  _createClass(AccordionPanel, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          style = _this$props3.style,
          title = _this$props3.title,
          children = _this$props3.children,
          isActive = _this$props3.isActive,
          disabled = _this$props3.disabled,
          hasArrow = _this$props3.hasArrow,
          arrowPosition = _this$props3.arrowPosition;
      var panelClassName = classNames({
        'roo-accordion-panel': true,
        'roo-accordion-panel-disabled': disabled
      }, className);
      var contentClassName = classNames({
        'roo-accordion-panel-content': true,
        'roo-accordion-panel-active': isActive
      });
      return /*#__PURE__*/React.createElement("div", {
        className: panelClassName,
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-accordion-panel-header",
        onClick: this.handlePanelClick
      }, hasArrow && arrowPosition === 'left' ? this.renderIcon() : null, title, hasArrow && arrowPosition === 'right' ? this.renderIcon() : null), /*#__PURE__*/React.createElement("div", {
        className: contentClassName
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-accordion-panel-box"
      }, children)));
    }
  }]);

  return AccordionPanel;
}(React.PureComponent);

AccordionPanel.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isActive: PropTypes.bool,
  disabled: PropTypes.bool,
  hasArrow: PropTypes.bool
};
AccordionPanel.defaultProps = {
  disabled: false,
  className: '',
  style: {},
  title: '',
  isActive: false,
  hasArrow: true
};
export default AccordionPanel;